//Generated File 
export default class ChatMessageType{
	static readonly Audio = `Audio`;
	static readonly Contact = `Contact`;
	static readonly File = `File`;
	static readonly Image = `Image`;
	static readonly Location = `Location`;
	static readonly System = `System`;
	static readonly Text = `Text`;
	static readonly Video = `Video`;
}
